"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortValues = void 0;
var SortValues;
(function (SortValues) {
    SortValues[SortValues["ASC"] = 1] = "ASC";
    SortValues[SortValues["DESC"] = -1] = "DESC";
})(SortValues = exports.SortValues || (exports.SortValues = {}));
//# sourceMappingURL=sort-values.enum.js.map